import React from "react";

const ListItem = ({ children, index }) => {
  return (
    <li className="flex items-center text-xs font-medium mb-2 ">
      <div className="mr-4 font-bold">{index + 1}</div>
      <div className="bg-blue-200 w-fit p-2 rounded-full">
        <div
          className="w-4 h-4 bg-contain"
          style={{ backgroundImage: 'url("/images/co2.png")' }}
        />
      </div>
      <div className="ml-6">{children}</div>
    </li>
  );
};

export default ListItem;
